"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexerRegistry__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "metadata",
                type: "bytes32",
            },
        ],
        name: "RegisterIndexer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "controller",
                type: "address",
            },
        ],
        name: "RemoveControllerAccount",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "SetCommissionRate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "controller",
                type: "address",
            },
        ],
        name: "SetControllerAccount",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "UnregisterIndexer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "metadata",
                type: "bytes32",
            },
        ],
        name: "UpdateMetadata",
        type: "event",
    },
    {
        inputs: [],
        name: "PER_BILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_MILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_TRILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ZERO_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "commissionRates",
        outputs: [
            {
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "valueAt",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "valueAfter",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "getCommissionRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "getController",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_minimumStakingAmount",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_address",
                type: "address",
            },
        ],
        name: "isIndexer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "metadata",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minimumStakingAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "_metadata",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "rate",
                type: "uint256",
            },
        ],
        name: "registerIndexer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "removeControllerAccount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "rate",
                type: "uint256",
            },
        ],
        name: "setCommissionRate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "controller",
                type: "address",
            },
        ],
        name: "setControllerAccount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
        ],
        name: "setSettings",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "setminimumStakingAmount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settings",
        outputs: [
            {
                internalType: "contract ISettings",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unregisterIndexer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_metadata",
                type: "bytes32",
            },
        ],
        name: "updateMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class IndexerRegistry__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "IndexerRegistry";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IndexerRegistry__factory = IndexerRegistry__factory;
IndexerRegistry__factory.bytecode = _bytecode;
IndexerRegistry__factory.abi = _abi;
